<template>
  <div
    v-if="status"
    class="onboarding_container"
  >
    <div class="onboarding_initial_form">
      <ElectronInvisibleHeader v-if="isElectronApp" />
      <div class="form-wrapper">
        <SmallLogo />
        <h1
          class="onboarding_form_title"
          :class="{ 'invite-empty': !displayButton }"
        >
          {{ linkTitle }}
        </h1>
        <h2
          v-if="status === 'notEnoughSeatsAvailable'"
          class="text-text-default text-sm font-normal mt-2"
        >
          {{ translate('thisWorkspaceCantAcceptAnyMoreMembers') }}
        </h2>
        <ButtonCustom
          v-if="!loading && displayButton"
          class="login-button"
          type="attention"
          :text="translate('resendInviteLink')"
          @click="resendCode"
        />
        <div
          v-if="loading && displayButton"
          :class="{ 'login-progress': loading }"
          class="login-button"
        >
          {{ translate('sending') }}
        </div>
        <p
          class="sign-in-existing-workspace"
          @click="goToLogin"
        >
          {{ translate('SignInIntoExistingWorkspace') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SmallLogo from '@/components/elements/SmallLogo';
import ButtonCustom from '@/components/elements/ButtonCustom';
import loginMixin from '@/mixins/loginMixin';
import preloadAppResources from '@/mixins/preloadAppResources';
import ElectronInvisibleHeader from '../../widgets/ElectronInvisibleHeader.vue';
import electronHelpersMixin from '@/mixins/electronHelpersMixin';

export default {
  name: 'StJoin',
  components: {
    SmallLogo,
    ButtonCustom,
    ElectronInvisibleHeader,
  },
  mixins: [loginMixin, preloadAppResources, electronHelpersMixin],
  data() {
    return {
      loading: false,
      inviteId: '',
      code: '',
      status: '',
      showButton: true,
    };
  },

  computed: {
    linkTitle() {
      switch (this.status) {
        case 'inviteAccepted':
          return this.translate('inviteLinkAccepted');
        case 'linkEmpty':
          return this.translate('inviteDoesntExist');
        case 'codeSent':
          return this.translate('newInviteLinkSent');
        case 'codeNotSent':
          return this.translate('couldntResendLink');
        case 'codeIncorrect':
          return this.translate('inviteCodeIncorrect');
        case 'noLongerValid':
          return this.translate('inviteNoLongerValid');
        case 'notEnoughSeatsAvailable':
          return this.translate('thereAreNoFreeSeatsForThisWorkspace');
        default:
          return '';
      }
    },
    displayButton() {
      return this.showButton;
    },
  },

  created() {
    this.storeQueryString();
    this.login();
  },

  mounted() {
    this.$nextTick(() => {
      this.onPageLoad();
    });
  },

  methods: {
    storeQueryString() {
      const query = { ...this.$route.query };
      if (!query.invite_id) {
        this.status = 'linkEmpty';
        this.showButton = false;
        return;
      }
      this.inviteId = query.invite_id;
      if (query.link_code) {
        this.code = query.link_code;
      }
    },

    goToLogin() {
      this.$router.push('/workspaces').catch(() => {
        // suppress the error in router navigation guard and
        // do nothing, router will redirect to login if it can not go to workspaces
      });
    },

    login() {
      if (!this.inviteId) return;
      this.$store
        .dispatch('loginWithInviteLink', {
          inviteId: this.inviteId,
          code: this.code,
        })
        .then((response) => {
          this.$store.dispatch('setRedirectProjectId', response.data.project_id);
          this.$store.dispatch('setCurrentTeamId', response.data.team_id);
          this.tryFetchingUser();
        })
        .catch((error) => {
          const errMsg = error.response.data.message;
          if (errMsg) {
            switch (errMsg) {
              case 'invite already accepted':
                this.status = 'inviteAccepted';
                this.showButton = false;
                break;
              case 'not enough seats available':
                this.status = 'notEnoughSeatsAvailable';
                this.showButton = false;
                break;
              case 'invite link code is incorrect - please request a new invite link':
                this.status = 'codeIncorrect';
                break;
              case 'invite link no longer valid - please request a new invite link':
                this.status = 'noLongerValid';
                break;
              case 'invite does not exist':
              default:
                this.status = 'linkEmpty';
                this.showButton = false;
            }
          }
        });
    },

    resendCode() {
      this.loading = true;
      this.$store
        .dispatch('resendInviteLink', { inviteId: this.inviteId })
        .then(() => {
          this.status = 'codeSent';
          this.loading = false;
          this.showButton = false;
        })
        .catch(() => {
          this.status = 'codeNotSent';
          this.loading = false;
          this.showButton = false;
        });
    },
  },
};
</script>
